module.exports = __webpack_public_path__ + "static/media/one-stack-nav-inactive.82b9b50e.svg";